import {request} from '@/assets/js/api/_helpers'


const ENDPOINT_REQUESTS_MOVEMENTS_CONTROL = '/api/requests/controls/movements'


export default {
    list: (config) => request( 'GET', ENDPOINT_REQUESTS_MOVEMENTS_CONTROL, config),
    retrieve: ({id, ...config}) => request( 'GET', `${ENDPOINT_REQUESTS_MOVEMENTS_CONTROL}/${id}`, config),
}